var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.452 13.0718L8.64197 9.26109C6.94708 10.4661 4.6116 10.1713 3.26922 8.58304C1.92684 6.99476 2.02541 4.64281 3.49597 3.17242C4.96614 1.70138 7.31832 1.60239 8.9069 2.9447C10.4955 4.287 10.7904 6.62272 9.58531 8.31775L13.3953 12.1284L12.4526 13.0711L12.452 13.0718ZM6.32397 3.33374C5.05977 3.33346 3.9691 4.22087 3.71229 5.45871C3.45548 6.69655 4.10311 7.9446 5.26309 8.44725C6.42307 8.94989 7.77657 8.56897 8.50413 7.53512C9.2317 6.50127 9.13335 5.09863 8.26864 4.17642L8.67197 4.57642L8.21731 4.12309L8.2093 4.11509C7.7105 3.6132 7.03157 3.33184 6.32397 3.33374Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f11774c24a615fb6cc205c6e7c7c1d87.svg";
export { ForwardRef as ReactComponent };